import React from 'react';

interface FacebookIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export default function FacebookIcon({ width = 22, height = 22, className = '' }: FacebookIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M21.5 11C21.5 5.20145 16.7986 0.5 11 0.5C5.20145 0.5 0.5 5.20145 0.5 11C0.5 16.2404 4.33912 20.5845 9.35951 21.373V14.0359H6.6928V11H9.35951V8.68619C9.35951 6.05491 10.9276 4.60048 13.3256 4.60048C14.4744 4.60048 15.6763 4.80572 15.6763 4.80572V7.38975H14.3518C13.048 7.38975 12.6405 8.19892 12.6405 9.03023V11H15.5523L15.0872 14.0359H12.6405V21.373C17.6609 20.586 21.5 16.2419 21.5 11Z"
        fill="#4B5563"
      />
      <path
        d="M15.0871 14.036L15.5522 11.0001H12.6404V9.03034C12.6404 8.2005 13.0465 7.38986 14.3518 7.38986H15.6763V4.80583C15.6763 4.80583 14.4743 4.60059 13.3255 4.60059C10.9276 4.60059 9.35943 6.05355 9.35943 8.6863V11.0001H6.69272V14.036H9.35943V21.3731C9.89396 21.4573 10.4418 21.5001 10.9999 21.5001C11.5581 21.5001 12.1059 21.4558 12.6404 21.3731V14.036H15.0871Z"
        fill="white"
      />
    </svg>
  );
}
